/**
 * Console entry — wires the hash router to the pages and exposes the
 * management API + session store. This is a thin shell; state management
 * for each page stays local so the privacy axes never get collapsed.
 */

import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { routeOf, PAGE_NAMES } from "./router.js";
import { LoginGate, LIVE_PAGES } from "./live.js";

export function App(): React.ReactElement {
  const [route, setRoute] = useState(() => routeOf(window.location.hash));
  useEffect(() => {
    const onHash = () => setRoute(routeOf(window.location.hash));
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);
  const livePage = LIVE_PAGES[route.page];
  const LivePage = livePage ?? ((): React.ReactElement => <h1>Page not found.</h1>);
  return (
    <div className="console">
      <nav aria-label="Console">
        <ul>
          <li>
            <a href="#/setup">Setup</a>
          </li>
          <li>
            <a href="#/routes">Routes</a>
          </li>
          <li>
            <a href="#/policies">Policies</a>
          </li>
          <li>
            <a href="#/decisions">Decisions</a>
          </li>
          <li>
            <a href="#/quota">Quota</a>
          </li>
          <li>
            <a href="#/cache">Cache</a>
          </li>
          <li>
            <a href="#/privacy">Privacy</a>
          </li>
          <li>
            <a href="#/credentials">Credentials</a>
          </li>
          <li>
            <a href="#/billing">Billing</a>
          </li>
          <li>
            <a href="#/security">Security</a>
          </li>
          <li>
            <a href="#/evals">Evals</a>
          </li>
        </ul>
      </nav>
      <main>
        {route.page === "notfound" ? (
          <h1>Page not found. {PAGE_NAMES.length} pages available.</h1>
        ) : null}
        {route.page !== "notfound" && livePage !== undefined ? <LivePage /> : null}
      </main>
    </div>
  );
}

export function ConsoleRoot(): React.ReactElement {
  return (
    <LoginGate>
      <App />
    </LoginGate>
  );
}

const rootElement = document.getElementById("root");
if (rootElement !== null) {
  createRoot(rootElement).render(<ConsoleRoot />);
}
